module.exports = ".stats__placeholder {\n  min-height: 120px; }\n\n.white-space-no-wrap {\n  white-space: nowrap; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/settings/quote-invoice-templates/qt-templates/qt-templates-list/qt-templates-list.component.scss
// module id = ./web/modern/components/settings/quote-invoice-templates/qt-templates/qt-templates-list/qt-templates-list.component.scss
// module chunks = 0